import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';

import { CommonFeatureModule } from '@app/common-feature';

import { NgforSkipItem } from './pipes/ngfor-skip-item.pipe';
import { LowercasePipe } from './pipes/lowercase.pipe';
import { NgForSkipGroupPipe } from './components/toolbar/ng-for-skip-group.pipe';
import { AutofocusDirective } from './directives/ngAutofocus';

import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { ButtonGroupComponent } from './components/toolbar/button-group/button-group.component';
import { MoreGroupComponent } from './components/toolbar/more-group/more-group.component';
import { DocumentViewComponent } from './components/document-view/document-view.component';
import { TabsComponent } from './components/tabs/tabs.component';
import { LanguagesComponent } from './components/languages/languages.component';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { SliderComponent } from './components/slider/slider.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { ActionComponent } from './components/action/action.component';
import { HeaderComponent } from './components/header/header.component';
import { StatusbarComponent } from './components/statusbar/statusbar.component';
import { AttachmentsComponent } from './components/attachments/attachments.component';
import { MySignatureComponent } from './components/my-signature/my-signature.component';
import { ContextMenuComponent } from './components/context-menu/context-menu.component';
import { AttachmentUploadComponent } from './components/attachments/attachment-upload/attachment-upload.component';
import { TranslateModule } from '@ngx-translate/core';
import { CheatMobileInputComponent } from './components/cheat-mobile-input/cheat-mobile-input.component';
import { AppZoomComponent } from './components/app-zoom/app-zoom.component';
import { WelcomeComponent } from './components/themes/lite/welcome/welcome.component';

@NgModule({
  imports: [CommonModule, TranslateModule, CommonFeatureModule],
  declarations: [
    NgforSkipItem,
    ToolbarComponent,
    ButtonGroupComponent,
    MoreGroupComponent,
    DocumentViewComponent,
    TabsComponent,
    LanguagesComponent,
    TooltipComponent,
    SliderComponent,
    SidebarComponent,
    ActionComponent,
    HeaderComponent,
    StatusbarComponent,
    AttachmentsComponent,
    MySignatureComponent,
    ContextMenuComponent,
    AttachmentUploadComponent,
    LowercasePipe,
    NgForSkipGroupPipe,
    AutofocusDirective,
    CheatMobileInputComponent,
    AppZoomComponent,
    WelcomeComponent,
  ],
  exports: [
    CommonModule,
    CommonFeatureModule,
    NgforSkipItem,
    ToolbarComponent,
    ButtonGroupComponent,
    MoreGroupComponent,
    DocumentViewComponent,
    TabsComponent,
    LanguagesComponent,
    TooltipComponent,
    SliderComponent,
    SidebarComponent,
    ActionComponent,
    HeaderComponent,
    StatusbarComponent,
    AttachmentsComponent,
    MySignatureComponent,
    ContextMenuComponent,
    AttachmentUploadComponent,
    LowercasePipe,
    NgForSkipGroupPipe,
    AutofocusDirective,
    CheatMobileInputComponent,
    TranslateModule,
    AppZoomComponent,
    WelcomeComponent,
  ],
})
export class SharedModule {}
